// Inbound filters passed to Sentry.init. Matching events are dropped in the
// browser, so they never reach Sentry, never alert, and cost no quota.
//
// Only add noise we cannot fix in our own code, and cite the Sentry issue that
// proves it. Errors thrown by Stripe, Plaid, Google Maps or Google sign-in stay
// visible on purpose: they usually mean we called the library wrong.

// Matched as a substring of the error message ("Type: message" or "message").
export const ignoreErrors = [
  // Browser warning that a ResizeObserver callback overran a frame. Harmless.
  // GO4ELLIS-BACKEND-30M, -535, -55B, -53B, -56P, -56R, -562, -55H
  'ResizeObserver loop completed with undelivered notifications',
  'ResizeObserver loop limit exceeded', // older Chrome wording of the same warning

  // Microsoft Outlook Safe Links scanner opening links from our emails.
  // GO4ELLIS-BACKEND-36Q
  'Object Not Found Matching Id:',

  // Injected by iOS in-app browsers (Facebook, Instagram). GO4ELLIS-BACKEND-55S
  '_AutofillCallbackHandler',
];

// Matched against the URL of the script that threw (the top stack frame), so an
// error that passes through these scripts but is thrown by our bundle is kept.
export const denyUrls = [
  // Browser extensions. GO4ELLIS-BACKEND-56J, -56H, -574, -56T, -56S
  /^(chrome|moz|safari(-web)?)-extension:\/\//i,

  // reCAPTCHA internals. GO4ELLIS-BACKEND-575, -579, -55A, -576
  /\/recaptcha\/(api\.js|releases\/)/i,

  // Analytics and marketing tags. Their failures don't affect the app.
  /googletagmanager\.com\//i, // GO4ELLIS-BACKEND-54T, -53N
  /hs-analytics\.net\//i, // HubSpot tracking, GO4ELLIS-BACKEND-566
  /licdn\.com\//i, // LinkedIn Insight, GO4ELLIS-BACKEND-559
  /gist\.build\//i, // Customer.io in-app messages, GO4ELLIS-BACKEND-546, -52E
  /assets\.customer\.io\//i, // Customer.io track.js and in-app, GO4ELLIS-BACKEND-4N2
  /\/logger-1(\.min)?\.js/i, // LogRocket recorder (CDN host varies), GO4ELLIS-BACKEND-4N1
];

export const sentryFilters = { ignoreErrors, denyUrls };

// The hosts we serve the app on, and the Sentry environment each reports as.
// Anything else is not reported: localhost, and the bare server IPs that
// scanners load with outdated headless browsers, whose crashes in Stripe.js,
// Customer.io and LogRocket we can't fix. GO4ELLIS-BACKEND-STAGING-256, -257,
// -258, -259
const ENVIRONMENTS = {
  'app.go4.io': 'production',
  'staging.go4.io': 'staging',
};

// Options for Sentry.init that depend on where the page was loaded.
export const sentryEnvironmentOptions = hostname => {
  const environment = ENVIRONMENTS[hostname];
  return { enabled: Boolean(environment), environment };
};
